import axios from "axios";
import { setToken } from "../../../Reducer/loginReducer";

export class OTPFunction {

  ErrorValidationConstant = "Please Enter Valid Code.";

  async OTP(
    body,
    navigation,
    token,
    setToastConfig,
    toastConfig,
    setvalidation,
    dispatch,
    setLoading
  ) {
    setLoading(true);
    await axios
      .post(`${process.env.REACT_APP_API_URL}/api/v1/user/verify/otp`, body, {
        headers: {
          token,
        },
      })
      .then((val) => {
        setLoading(false);
        if (val?.data?.success) {
          dispatch(setToken(val?.data?.result?.token));
          navigation("/reset-password");
        }
      })
      .catch((err) => {
        setLoading(false);
        if (
          err?.response?.data?.status_code === "404" ||
          err?.response?.data?.message === "Not Found"
        ) {
          setvalidation(this.ErrorValidationConstant);
        }
        if (
          err?.response?.statusText === "Unauthorized" ||
          err?.response?.status === "401"
        ) {
          setvalidation(this.ErrorValidationConstant);
        }
        if (err?.response?.statusText === "Too Many Requests") {
          setToastConfig({
            ...toastConfig,
            isVisible: true,
            type: "error",
            message: "Too many requests, please try again later.",
          });
          setTimeout(() => {
            setToastConfig({
              ...toastConfig,
              isVisible: false,
              type: "error",
              message: "Too many requests, please try again later.",
            });
          }, 1800);
        }
        if (
          err?.response?.data?.status_code === "400" ||
          err?.response?.data?.message === "Bad Request"
        ) {
          setvalidation(this.ErrorValidationConstant);
        }
        if (!err.response) {
          setToastConfig({
            ...toastConfig,
            isVisible: true,
            type: "error",
            message: "Network Error!",
          });
          setTimeout(() => {
            setToastConfig({
              ...toastConfig,
              isVisible: false,
              type: "error",
              message: "Network Error!",
            });
          }, 1800);
        }
      });
  }
}
